export default __webpack_public_path__ + "static/media/lee-hyerin.e2230ebe.jpg";